﻿(function($, path){
    'use strict';

    function getLatestRelease(repoName, callbackFn) {
        $.getJSON("https://api.github.com/repos/Particular/" + repoName + "/releases", function (releases) {
            var latest = _(releases)
                .filter({ prerelease: false })
                .map(function (r) {
                    var versionSplit = r.tag_name.split('.');
                    if (versionSplit.length !== 3) {
                        return null;
                    }
                    return {
                        release: r,
                        major: parseInt(versionSplit[0]),
                        minor: parseInt(versionSplit[1]),
                        patch: parseInt(versionSplit[2]),
                    };
                })
                .filter(function (r) { return !!r; })
                .orderBy(['major', 'minor', 'patch'], ['desc', 'desc', 'desc'])
                .head();

            callbackFn(latest.release);
        });
    }

    $(function() {

        if (path === '/downloads') {
            ['NServiceBus', 'ServiceControl', 'ServicePulse', 'ServiceInsight'].forEach(function (repoName) {
                getLatestRelease(repoName, function (release) {
                    $('#' + repoName + 'ReleaseVersion')
                        .html('v' + release.tag_name)
                        .removeClass('ploading');
                });
            });
            return;
        }

        // Now must be on one of the individual download pages
        var pageMap = {
            '/start-servicecontrol-download': { repo: 'ServiceControl', gaMethod: 'serviceControlDownload' },
            '/start-servicepulse-download': { repo: 'ServicePulse', gaMethod: 'servicePulseDownload' },
            '/start-serviceinsight-download': { repo: 'ServiceInsight', gaMethod: 'serviceInsightDownload' }
        };

        var config = pageMap[path];

        getLatestRelease(config.repo, function (release) {
            var asset = release.assets[0];
            var url = asset.browser_download_url;
            $('#download_link').attr('href', url);
            GA4Event[config.gaMethod](asset.name, url);
            setTimeout(function () {
                window.location = url;
            }, 1000);
        });

    });

}(jQuery, document.location.pathname));